import { createReducer, on } from '@ngrx/store';
import * as fromPaymentsAndStatementsActions from '../actions';
import { IPaymentStatementsRequest, IPaymentStatementsResponse } from '../dto/statements.dto';

export const statementFeatureKey = 'statement';

export interface State {
  loadPaymentStatementsRequest: IPaymentStatementsRequest;
  loadPaymentStatementsResponse: IPaymentStatementsResponse;
  loadPaymentsStatementsFailure: Error | any;
  loaded: boolean;
}

export const initialState: State = {
  loaded: false,
  loadPaymentStatementsRequest: undefined,
  loadPaymentStatementsResponse: undefined,
  loadPaymentsStatementsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromPaymentsAndStatementsActions.loadStatements, (state, action) => ({
    ...state,
    loadPaymentStatementsRequest: action.request
  })),
  on(fromPaymentsAndStatementsActions.loadStatementsSuccess, (state, action) => ({
    ...state,
    loadPaymentStatementsResponse: action.response,
    loaded: true
  })),
  on(fromPaymentsAndStatementsActions.loadStatementsFailure, (state, action) => ({
    ...state,
    loadPaymentsStatementsFailure: action.error
  }))
);

export const loadPaymentStatementsResponse = (state: State) => state.loadPaymentStatementsResponse;
export const loadPaymentsStatementsFailure = (state: State) => state.loadPaymentsStatementsFailure;
